// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__u_8wA","title":"Header_title__37EyW","side":"Header_side__3Yl89"};